/* Copyright 2013 - 2024 Waiterio LLC */
import React, { useEffect } from 'react'
import { useContext } from '@monorepo/context/index.js'
import { darken, lighten } from 'polished'

const IframeMessenger = ({ children }) => {
  const [, produce] = useContext()
  // console.log('IframeMessenger')
  const onMessage = React.useCallback(
    event => {
      // console.log('onMessage', event)
      if (event?.data?.[0] === 'closeChat') {
        window?.parent?.postMessage({ type: 'closeChat' }, '*')
      } else if (event?.data?.[0] === 'hideChat') {
        window?.parent?.postMessage({ type: 'hideChat' }, '*')
      } else if (event?.data?.[0] === 'openChat') {
        window?.parent?.postMessage({ type: 'openChat' }, '*')
      } else if (event?.data?.[0] === 'setDeviceType') {
        produce(draft => {
          draft.deviceType = event?.data?.[1]
        })
      } else if (event?.data?.[0] === 'setVersion') {
        produce(draft => {
          draft.version = event?.data?.[1]
        })
      } else if (event?.data?.[0] === 'setVersionNative') {
        produce(draft => {
          draft.versionNative = event?.data?.[1]
        })
      } else if (event?.data?.[0] === 'setWebsiteId') {
        produce(draft => {
          draft.websiteId = event?.data?.[1]
        })
      } else if (event?.data?.[0] === 'setUserAvatarUrl') {
        produce(draft => {
          draft.userAvatarUrl = event?.data?.[1]
        })
      } else if (event?.data?.[0] === 'setUserId') {
        produce(draft => {
          draft.userId = event?.data?.[1]
          draft.userIdSignature = event?.data?.[2]
        })
      } else if (event?.data?.[0] === 'setUserEmail') {
        produce(draft => {
          draft.userEmail = event?.data?.[1]
          draft.userEmailSignature = event?.data?.[2]
        })
      } else if (event?.data?.[0] === 'setUserNickname') {
        produce(draft => {
          draft.userNickname = event?.data?.[1]
        })
      } else if (event?.data?.[0] === 'setUserPhone') {
        produce(draft => {
          draft.userPhone = event?.data?.[1]
        })
      } else if (event?.data?.[0] === 'setBrandColor') {
        let colorPrimary = event?.data?.[1]
        let colorPrimaryLight = lighten(0.08, colorPrimary)
        let colorPrimaryDark = darken(0.08, colorPrimary)

        let variables = [
          ['--color-hover', colorPrimaryLight],
          ['--color-focus', colorPrimaryLight],
          ['--color-active', colorPrimaryDark],
          ['--color-primary', colorPrimary],
          ['--color-primary-dark', colorPrimaryDark],
          ['--color-primary-darker', darken(0.16, colorPrimary)],
          ['--color-primary-darkest', darken(0.24, colorPrimary)],
          ['--color-primary-light', colorPrimaryLight],
          ['--color-primary-lighter', lighten(0.16, colorPrimary)],
          ['--color-primary-lightest', lighten(0.24, colorPrimary)],
          ['--color-background', '#f5f7fa'],
        ]

        variables.forEach(([key, value]) =>
          document.documentElement.style.setProperty(key, value),
        )
      } else if (event?.data?.[0] === 'setMetadata') {
        produce(draft => {
          draft.metadata = draft.metadata || {}
          draft.metadata[event?.data?.[1]] = event?.data?.[2]
        })
      } else if (event?.data?.[0] === 'showChat') {
        window?.parent?.postMessage({ type: 'showChat' }, '*')
      } else if (event?.data?.[0] === 'setBottom') {
        window?.parent?.postMessage(
          { type: 'setBottom', bottom: event?.data?.[1] },
          '*',
        )
      }
    },
    [produce],
  )

  useEffect(() => {
    window.addEventListener('message', onMessage)
    // console.log('setup window addEventListener message')
    return () => window.removeEventListener('message', onMessage)
  }, [onMessage])

  return children
}

export default IframeMessenger
